/// <reference types="vite/client" />
export const isVisualRegressionEnv = !!process.env.STORYBOOK_SNAPSHOT
